import styled from "styled-components";
import imageProfile from "../../Assets/Images/manasWorking.jpg";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  
`;
export const ImageBackground = styled.div`
  position: relative;
  height: 300px;
  /* width: 100vw; */
  background-image: url(${imageProfile});
  background-size: cover;
  background-position: center;

  ::before {
    content: "";
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    background-color: rgba(152, 66, 211, 0.63);
  }
`;

export const SubmitInput = styled.input`
  padding: 10px;
  height: 50px;
  border: none;
  border-radius: 8px;
  background: ${(props) => (props.primary ? "palevioletred" : "#9b59b6")};
  cursor: ${(props) => (props.loading ? "progress" : "pointer")} !important;
  color: #fff;
  margin: 20px;
  font-weight: bold;
`;

export const ContentModal = styled.div`
    z-index: 1000;
    position: relative;

`;